import { Box, Typography } from "@mui/material";
import { toast } from "react-toastify";
import useDoNotCallLead from "@/modules/lead-page/hooks/lead-info/lead-actions/do-not-call-lead.hook";
import { useEffect } from "react";
import PermissionGuard from "@/modules/common/components/wrappers/permission-guard";
import { PermissionLevel, PermissionsEnum } from "@/modules/common/types";
import { queryClient } from "@/queryClient";
import { nawyTheme } from "@/styles/nawy-theme/nawy-theme";

const DoNotCall = () => {
  const { handleConfirmUpdate, lead, isSuccess } = useDoNotCallLead();

  useEffect(() => {
    if (isSuccess) {
      toast.success(
        lead?.data?.lead?.do_not_call === false
          ? "Calls on this lead disallowed"
          : "Calls on this lead allowed",
        {
          position: "bottom-left",
          autoClose: 3000,
        }
      );
      queryClient.invalidateQueries(["getLead"]);
    }
  }, [isSuccess]);

  return (
    <>
      {lead?.data?.lead?.do_not_call ? (
        <PermissionGuard
          permissions={[
            {
              name: PermissionsEnum.TOGGLE_DONOT_CALL_CUSTOMER,
              level: PermissionLevel.WRITE,
            },
          ]}
        >
          <Box
            sx={{
              display: "flex",
              gap: nawyTheme.nawy.spacing.xs,
              padding: nawyTheme.nawy.spacing.xs,
              alignItems: "center",
              width: "100%",
              height: "100%",
              cursor: "pointer",
              ":hover": {
                backgroundColor: nawyTheme.nawy.colors.semantic.layer.secondary,
              },
            }}
            onClick={() =>
              handleConfirmUpdate({
                customer: { doNotCall: false },
              })
            }
          >
            <Typography
              sx={{
                color: lead?.data?.lead?.do_not_call
                  ? nawyTheme.nawy.colors.semantic.text.extension.positive
                  : nawyTheme.nawy.colors.semantic.text.extension.negative,
                ...nawyTheme.nawy.typography.english.variants.body.md.regular,
              }}
            >
              Allow Calls
            </Typography>
          </Box>
        </PermissionGuard>
      ) : (
        <Box
          sx={{
            display: "flex",
            gap: nawyTheme.nawy.spacing.xs,
            padding: nawyTheme.nawy.spacing.xs,
            alignItems: "center",
            width: "100%",
            height: "100%",
            cursor: "pointer",
            ":hover": {
              backgroundColor: nawyTheme.nawy.colors.semantic.layer.secondary,
            },
          }}
          onClick={() =>
            handleConfirmUpdate({
              customer: { doNotCall: true },
            })
          }
        >
          <Typography
            sx={{
              color: lead?.data?.lead?.do_not_call
                ? nawyTheme.nawy.colors.semantic.text.extension.positive
                : nawyTheme.nawy.colors.semantic.text.extension.negative,
              ...nawyTheme.nawy.typography.english.variants.body.md.regular,
            }}
          >
            Do Not Call
          </Typography>
        </Box>
      )}
    </>
  );
};

export default DoNotCall;
